import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IRootScopeService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {BrukerRessurs} from "felles/tjenester/ressurser/BrukerRessurs";
import {InnlastingsindikatorKontroller} from "web/moduler/basis/direktiver/innlastingsindikator";
import {MeldingTilBruker, Varighet} from "../../../../felles/tjenester/MeldingTilBruker";
import {gettextCatalog} from "angular-gettext";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {Debugger} from "debug";
import {Logger} from "felles/infrastruktur/Logging";
import {criiptoCallbackParamsFraStateParams} from "felles/komponenter/autentisering/criiptoautentiseringBasis";
import {CriiptoBindFraTokenSesjonstjeneste} from "web/tjenester/CriiptoBindFraTokenSesjonstjeneste";
import {Kontekst} from "felles/tjenester/Kontekst";
import {FellesAutentiseringsRessurs} from "felles/tjenester/ressurser/FellesAutentiseringsRessurs";

const debug:Debugger = require('debug')('AngiNyttPassordKontroller');

export class AngiNyttPassordKontroller {
    static regNavn = "angiNyttPassordKontroller";

    static forInjisering() {
        return [
            regNavn.ng.$rootScope,
            regNavn.ng.ui.$state,
            regNavn.ng.ui.$stateParams,
            Logger.regNavn,
            WebNavigasjon.regNavn,
            BrukerRessurs.regNavn,
            MeldingTilBruker.regNavn,
            CriiptoBindFraTokenSesjonstjeneste.regNavn,
            FellesAutentiseringsRessurs.regNavn,
            regNavn.gettext.gettextCatalog,
            AngiNyttPassordKontroller
        ]
    }

    criiptoCallbackparams: l.CriiptoCallbackParams;
    tokenVarighet = l.Tokenvarighet.kort;
    criiptoGuiModus = l.CriiptoGuiModus.erstatt;
    modell: l.NyttPassordFraTokenModell;
    kreverEid = false;
    private epost: string;
    private _visSkjema = false;

    lagrer = false;

    constructor(private $rootScope: IRootScopeService,
                private $state: StateService,
                $stateParams: any,
                private logger: Logger,
                private navigasjon: WebNavigasjon,
                private res: BrukerRessurs,
                private meldingTilBruker: MeldingTilBruker,
                private criiptoBindFraTokenSesjonstjeneste: CriiptoBindFraTokenSesjonstjeneste,
                fellesAutentiseringsRes: FellesAutentiseringsRessurs,
                private gettextCatalog: gettextCatalog) {
        this.modell = {token: $stateParams.token, passord: ''};
        this.epost = $stateParams.epost;
        this.criiptoCallbackparams = criiptoCallbackParamsFraStateParams($stateParams);
        fellesAutentiseringsRes.resettokenKreverEid(this.modell.token).$promise
          .then(respons => this.kreverEid = respons.kreverEid);
    }

    skjemaVises() {
        return this._visSkjema;
    }

    visSkjema() {
        this._visSkjema = true;
    }
    skjulSkjema() {
        this._visSkjema = false;
    }

    eidValgt(){
        this.criiptoBindFraTokenSesjonstjeneste.lagre(this.epost, this.modell.token);
    }

    vedAutentisert(autentisert:l.AutentisertOkModell){
        this.criiptoBindFraTokenSesjonstjeneste.nullstill();
    }

    vedCriiptoAvbrutt(){
        this.criiptoBindFraTokenSesjonstjeneste.nullstill();
        this.navigasjon.gåTilInnloggingssiden('', true);
    }

    vedCriiptoFeil(feil:any){
        debug("criiptoFeil", feil)
        this.logger.error(feil)
        this.criiptoBindFraTokenSesjonstjeneste.nullstill();
        this.navigasjon.gåTilInnloggingssiden('', true);
    }

    lagre() {
        this.lagrer = true;
        this.$rootScope.$emit(InnlastingsindikatorKontroller.vis_innlasting);
        this.res.nyttPassordAngitt(this.modell).$promise
            .then(() => this.$state.go('forside.angi-nytt-passord-bekreftelse'))
            .catch(e => {
                const melding = this.gettextCatalog.getString('Passordnullstillingslenken din har gått ut på tid, klikk her for å gå til glemt passord-skjema');
                this.meldingTilBruker.advarselmelding(`<span class="e2e-resetlenke-utloept-mld">${melding}</span>`, Varighet.sideskift, () => {
                    this.$state.go('forside.glemt-passord');
                    return true;
                });
            })
            .finally(() => {
                this.lagrer = false;
                this.$rootScope.$emit(InnlastingsindikatorKontroller.innlasting_ferdig);
            });
    }
}
